import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Internet is a Beautiful Place in the World's Most Exclusive Chatroom",
  "description": "",
  "published": "2017-03-24T00:00:00.000Z",
  "redirect_from": ["/blog/internet-beautiful-place/swizec/7513"],
  "categories": "Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "cBVOsyH5u8Y",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`On Tuesday, I launched a chatroom. But not just any chatroom. Oh no, it’s a hacker haven. A chatroom that you can only get into if you `}<a parentName="p" {...{
        "href": "http://school.shoutem.com/lectures/chat-app-firebase-redux-react-native/"
      }}>{`follow my React Native tutorial`}</a>{`, and build the app, and run it in a simulator.`}</p>
    <p>{`Or if you write an HTML clone.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Phase 1 complete 😆😇 `}<a parentName="p" {...{
          "href": "https://t.co/3nj1tQP8pE"
        }}>{`pic.twitter.com/3nj1tQP8pE`}</a></p>{`— Luke Edwards (@lukeed05) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/lukeed05/status/844651989715726336"
      }}>{`March 22, 2017`}</a></blockquote>
    <p>{`And you thought IRC was hard for not-nerds to figure out. Ha! ? My global chatroom is `}<em parentName="p">{`exclusive`}</em>{`.`}</p>
    <p>{`I launched the chatroom at 10am on Tuesday. The tutorial went out, the social posts went out, I fired up my simulator, and then I waited. Like a spider in disguise. Or a fly waiting to be eaten ?`}</p>
    <p>{`Seven hours later, at 1 minute and 8 seconds past 5pm, somebody said `}<em parentName="p">{`"Howdy"`}</em>{`. It worked! I asked the internet for lulz and the internet lulzed! ??`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`IT HAPPENED SOMEONE SAID HELLO IN THE GLOBAL CHATROOM! MY LIFE IS COMPLETE `}<a parentName="p" {...{
          "href": "https://t.co/qJ709Wmqn7"
        }}>{`pic.twitter.com/qJ709Wmqn7`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/844346387168866305"
      }}>{`March 22, 2017`}</a></blockquote>
    <p>{`Then one hour later, it happened again. The top secret social experiment worked o/`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Another! The top secret social experiment is working `}<a parentName="p" {...{
          "href": "https://t.co/RhEfb0NI9l"
        }}>{`pic.twitter.com/RhEfb0NI9l`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/844357086083399680"
      }}>{`March 22, 2017`}</a></blockquote>
    <p>{`It was amazing. Nine hours exposed to the internet, available for anyone to say anything `}<em parentName="p">{`anonymously`}</em>{`. The worst that happened was that somebody said "ass".`}</p>
    <p>{`Faith in humanity restored! The internet is clean and pure. ?`}</p>
    <p>{`It got more interesting on Wednesday. Some more people came in to say hello. This time they pretended to be me.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/03/screenshot1.png",
        "alt": null
      }}></img></p>
    <p>{`React Native `}<inlineCode parentName="p">{`<Text>`}</inlineCode>{` doesn't render backslashes. Or does Firebase filter them out? ?`}</p>
    <p>{`Either way, shit was going down. For like twenty minutes, the chatroom was alive. Real. Busy like the public bazaar of an old village in Siberia.`}</p>
    <p>{`6 people came to say hello.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/03/users-screenshot.png",
        "alt": null
      }}></img></p>
    <p>{`That's a lot for a place that only exists as an unpublished app.`}</p>
    <p>{`And then, just as it had started, the fun was over. Firebase sent an automated message saying that we were done. That you can't just run a public chatroom by sharing Firebase account credentials with everyone. That we're abusing the system and that we should find better things to do.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`So that was fun while it lasted `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/ChatApp?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#ChatApp`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/0NU5NqBWah"
        }}>{`pic.twitter.com/0NU5NqBWah`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/844649016294039554"
      }}>{`March 22, 2017`}</a></blockquote>
    <p>{`I went into the Firebase console, found the link, copy pasted into the browser and`}</p>
    <lite-youtube {...{
      "videoid": "dQw4w9WgXcQ",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`?`}</p>
    <p>{`The internet is a beautiful place.`}</p>
    <p>{`My experiment is going ridiculously well. I'm gonna keep the simulator running for a few more days. Come say hi.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      